import React from 'react';
import { withRouter } from '../../common/withRouter';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  DataDefinitionList,
  EditableArea,
  Notification,
  Message,
  IconWithText,
  Loader,
  FormikInput,
  Tabs
} from '../../web.common';
import { sentenceCase } from 'change-case';
import withApi from '../higherOrderComponents/withApi';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import { Search } from '../misc/Search';
import { getApiErrorMessage } from '../../common/utils';
import { Divider, DetailsRightBar, NoLink, Link } from './DetailsRightBar';
import { mappedFacilityTypes } from '../../enums/FacilityTypes';
import {
  DisplayGuid,
  DisplayDate,
  DisplayType,
  DisplayAddress
} from '../items';
import { EditOpeningHours } from './EditOpeningHours';

const ResourceSplitInternal = () => {
  return 'This is the resource split page ...';
}

const ResourceSplit = withRouter(withApi(
  connect(({ user, categories }) => ({ isLoggedIn: !!user, categories }), {})(ResourceSplitInternal)
));

ResourceSplit.requiresLogin = true;
ResourceSplit.propTypes = { isLoggedIn: PropTypes.bool };

export default ResourceSplit;